import styled from 'styled-components';
export const Wrapper = styled.div `
  appearance: none;
  -webkit-appearance: none;
  flex: 0 0 4rem;
  margin: 0 1rem;

  ${({ theme: { attendeeQuantity } }) => attendeeQuantity}
`;
export const Element = styled.input `
  -moz-appearance: textfield;
  appearance: textfield;
  -webkit-appearance: textfield;
  min-width: 0;
  width: 4rem;
  border: none;
  text-align: center;
  padding: 0;
  outline: none !important;
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
export default {
    Wrapper,
    Element,
};
